import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalSubMedida, loadingModalSubMedida, editarSubMedidaPlanMovilidad, onAlertaPlanMovilidad } from "../actions";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import DateField from "../../../Shared/fields/DateField";
import SwitchField from "../../../Shared/fields/SwitchField";
import { compareTwoDates } from "../functions";

class ModalSubMedida extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fechaInicio: null,
      fechaLimite: null,
      subMedidaElegida: null,
      isLoad: false,
    };
  }

  componentDidUpdate = () => {
    if (!this.state.isLoad && this.props.isOpenSubMedidaModal) {
      this.setThisState();
    } else if ((this.state.isLoad && !this.props.isOpenSubMedidaModal)) {
      this.unSetThisState();
    }
  }

  setThisState = () => {
    this.setState({
      fechaInicio: (this.props.dataSubMedidaModal.fechaInicio) ? this.props.dataSubMedidaModal.fechaInicio : null,
      fechaLimite: (this.props.dataSubMedidaModal.fechaLimite) ? this.props.dataSubMedidaModal.fechaLimite : null,
      subMedidaElegida: (this.props.dataSubMedidaModal.subMedidaElegida) ? this.props.dataSubMedidaModal.subMedidaElegida : false,
      isLoad: true,
    });
  }

  unSetThisState = () => {
    this.setState({
      fechaInicio: null,
      fechaLimite: null,
      subMedidaElegida: false,
      isLoad: false,
    });
  }

  handlerSuccess = (id, elegida, inicio, limite) => {
    this.props.dispatch(loadingModalSubMedida(true));
    this.props.dispatch(editarSubMedidaPlanMovilidad(id, elegida, inicio, limite));
    this.props.dispatch(loadingModalSubMedida(false));
    this.handleCerrar();
  }

  handleCerrar= () => {
    this.props.dispatch(openCloseModalSubMedida(false, {}));
  }

  handleGuardar = () => {
    // validaciones!
    if (
      this.props.dataSubMedidaModal.fechaInicio === this.state.fechaInicio &&
      this.props.dataSubMedidaModal.fechaLimite === this.state.fechaLimite &&
      this.props.dataSubMedidaModal.subMedidaElegida === this.state.subMedidaElegida
    ) {
      this.props.dispatch(onAlertaPlanMovilidad("warning", "No se realizaron cambios..."));
      this.handleCerrar();
    } else if (this.state.subMedidaElegida) {
      if (this.state.fechaInicio && this.state.fechaLimite) {
        // valido si las fechas del plan límite es mayor a la otra
        if (compareTwoDates(this.state.fechaInicio, this.state.fechaLimite) === 1) {
          this.props.dispatch(onAlertaPlanMovilidad("error", "La fecha de inicio es mayor a la fecha límite"));
        } else {
          this.handlerSuccess(this.props.dataSubMedidaModal.idplanSubMedida, this.state.subMedidaElegida, this.state.fechaInicio, this.state.fechaLimite);
        }
      } else {
        this.props.dispatch(onAlertaPlanMovilidad("error", "Debe completar ambos campos de fechas..."));
      }
    } else {
      // asumo que la tengo que limpiar... entonces reinicio los valores en db...
      this.handlerSuccess(this.props.dataSubMedidaModal.idplanSubMedida, false, null, null);
    }
  }

  handleChange = (e) => {
    switch (e.element.id) {
      case "fechaInicioSubMedida":
        this.setState({ fechaInicio: (new Date(e.value)) });
        break;
      case "fechaLimiteSubMedida":
        this.setState({ fechaLimite: (new Date(e.value)) });
        break;
      case "activoSubMedida":
        this.setState({ subMedidaElegida: e.value });
        break;
      default:
    }
  }

  render() {
    return (
      <div>{ this.props.dataSubMedidaModal &&
        <Popup
          visible={this.props.isOpenSubMedidaModal}
          onHiding={this.handleCerrar}
          dragEnabled={false}
          height={400}
          width={500}
          title={this.props.dataSubMedidaModal.descripcion}
          showCloseButton
          contentComponent={() => (
            <div>
              <div style={{ position: "absolute", left: 20, right: 20 }}>
                {this.props.isLoadingSubMedidaModal && <LoadingOverlay />}
                <DateField
                  styleRoot={{ marginTop: 0 }}
                  label="Fecha inicio"
                  id="fechaInicioSubMedida"
                  onChange={this.handleChange}
                  type="date"
                  min={new Date()}
                  max={new Date().setFullYear(3000)}
                  value={this.state.fechaInicio}
                />
                <DateField
                  styleRoot={{ marginTop: 0 }}
                  label="Fecha límite"
                  id="fechaLimiteSubMedida"
                  onChange={this.handleChange}
                  type="date"
                  min={new Date()}
                  max={new Date().setFullYear(3000)}
                  value={this.state.fechaLimite}
                />
                <SwitchField
                  id="activoSubMedida"
                  label="Activar Acción"
                  onChange={this.handleChange}
                  switchedOffText="NO"
                  switchedOnText="SI"
                  visible
                  value={this.state.subMedidaElegida}
                />
              </div>
              <div className="button-row">
                <div><Button text="Cancelar" onClick={this.handleCerrar} /></div>
                <div><Button text="Guardar" type="success" onClick={this.handleGuardar} /></div>
              </div>
            </div>
          )}
        />
      }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenSubMedidaModal: state.planMovilidad.isOpenSubMedidaModal,
  isLoadingSubMedidaModal: state.planMovilidad.isLoadingSubMedidaModal,
  dataSubMedidaModal: state.planMovilidad.dataSubMedidaModal,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSubMedida);
